module.exports = __webpack_public_path__ + "img/Scotland.4a1b3290.svg";